<template>
  <section class="editPost">
    <UploadPostMedia @img-choice="handlePostImg" />
    <div class="hr"></div>
    <UploadCategory @category-choice="handleCategory" />
    <div class="hr"></div>
    <UploadTag @tag-choice="handleTag" />
    <div class="hr"></div>
    <div class="text-center pb-5">
      <form class="formPost" @submit.prevent="submitPost">
        <div class="formPost__header container">
          <label for="title">Titre de l'article :</label>
          <input type="text" id="title" name="title" v-model="form.title" />
        </div>
        <div class="container">
          <editor
            id="content"
            name="content"
            v-model="form.content"
            api-key="nplh2m653mu0dc8fa6iqkg3402enrlz4l2yi3tynxj3cu0uc"
            :init="{
              selector: '#content',
              height: 1200,
              menubar: false,
              skin: 'oxide-dark',
              content_css: 'dark',
              plugins:
                'preview searchreplace autolink autosave save directionality codesample visualblocks visualchars fullscreen image link codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists wordcount imagetools noneditable help charmap quickbars emoticons',
              codesample_languages: [
                { text: 'PHP', value: 'php' },
                { text: 'JavaScript', value: 'javascript' },
                { text: 'typescript', value: 'ts' },
                { text: 'Twig', value: 'twig' },
                { text: 'HTML/XML', value: 'markup' },
                { text: 'CSS', value: 'css' },
                { text: 'SCSS', value: 'scss' },
                { text: 'SASS', value: 'sass' },
                { text: 'SQL', value: 'sql' },
                { text: 'terminal', value: 'apacheconf' },
              ],
              menubar: 'file edit view insert format tools table help',
              toolbar:
                'undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen  preview save | insertfile image link anchor codesample | ltr rtl | help',
              toolbar_sticky: true,
              codesample_global_prismjs: true,
              link_default_protocol: 'http',
              content_style:
                'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
            }"
          />
        </div>
        <!--<textarea id="content" name="content" v-model="Post.content"> </textarea>-->
        <button type="submit" class="edit_btn">Enregistrer l'article</button>
      </form>
    </div>
  </section>
</template>

<script>
import UploadPostMedia from "@/components/plugins/UploadPostMedia.vue";
import UploadCategory from "@/components/plugins/UploadCategory.vue";
import UploadTag from "@/components/plugins/UploadTag.vue";
import Editor from "@tinymce/tinymce-vue";
import Prism from "prismjs";
import { mapActions } from "vuex";

export default {
  name: "UploadPost",
  components: { UploadPostMedia, UploadCategory, UploadTag, Editor },
  mounted() {
    // apply Prism highlighting to the rendered content
    Prism.highlightAll();
  },
  computed: {
    isLoggedIn: function () {
      return this.$store.getters.isAuthenticated;
    },
  },
  data() {
    return {
      form: {
        title: "",
        content: "",
      },
      category: null,
      postImg: null,
      tags: [],
    };
  },
  methods: {
    ...mapActions(["CreatePost"]),
    handleCategory(data) {
      this.category = data;
    },
    handlePostImg(data) {
      this.postImg = data;
    },
    handleTag(data) {
      this.tags = data.map((tag) => ({ label: tag }));
    },
    async submitPost() {
      try {
        const data = {
          img: this.postImg["@id"].substring(1),
          title: this.form.title,
          content: this.form.content,
          category: "api/categories/" + this.category.id,
          tags: this.tags,
        };
        await this.CreatePost(data).then(() => {
          // Redirection ici
          this.$router.push("/malazone");
        });
        this.showError = false;
      } catch (error) {
        this.showError = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.hr {
  width: 75%;
  height: 0.5px;
  margin: 100px auto;
  background-color: $color-primary;
}
.editPost {
  margin-bottom: 100px;
}
.formPost {
  &__header {
    display: flex;
    flex-direction: column;
    margin: 50px auto;
    & label {
      text-align: left;
      font-size: 1.9em;
      position: relative;
      width: fit-content;
      left: 10%;
      color: $bold-light-primary;
    }
    & input {
      width: 80%;
      margin: auto;
      padding: 10px 20px;
      border: 0.1px $color-primary solid;
      border-radius: 20px;
      background-color: $color-darker;
      color: $color-primary;
      text-align: center;
    }
  }
}
.edit_btn {
  width: fit-content;
  background: $color-primary !important;
  color: $color-text !important;
  border: 0.3px $color-text outset;
  border-radius: 30px;
  padding: 10px 20px;
  transition: all 0.3s ease-in-out;
  margin: 60px 10px;
  &:hover {
    background: $color-darker !important;
    color: $color-primary !important;
    border: 0.3px $color-text inset;
    transform: scale(95%);
  }
}
</style>
